/* Top bar campaign banner (snippets/btk-sales-bar-fixed): fills in the days left
   and rotates between its messages. Pages are cached, so the count is worked out
   here, in UK days, rather than in Liquid. */
(function () {
  var HOLD_MS = [6500, 4500];
  var LEAVE_MS = 280;

  function ukDay(date) {
    var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).format(date).split('-');
    return Date.UTC(+p[0], +p[1] - 1, +p[2]);
  }

  function daysLeftText(ends) {
    var p = String(ends || '').split('-');
    if (p.length !== 3) return '';
    var days = Math.round((Date.UTC(+p[0], +p[1] - 1, +p[2]) - ukDay(new Date())) / 864e5);
    if (days <= 0) return 'Last day!';
    return days === 1 ? '1 day left' : days + ' days left';
  }

  /* The banner's tile, and the pop-up's (snippets/btk-offer-popup). */
  document.querySelectorAll('[data-ends] [data-btk-days]').forEach(function (tile) {
    var text = daysLeftText(tile.closest('[data-ends]').getAttribute('data-ends'));
    if (text) { tile.textContent = text; tile.hidden = false; }
  });

  function start(banner) {
    var msgs = banner.querySelectorAll('.btk-kp-utilitybar-fixed-msg');
    if (msgs.length < 2) return;
    var at = 0;
    var hovering = false;
    banner.addEventListener('mouseenter', function () { hovering = true; });
    banner.addEventListener('mouseleave', function () { hovering = false; });

    function next() {
      if (hovering) { setTimeout(next, 500); return; }
      var cur = msgs[at];
      cur.classList.add('is-leaving');
      setTimeout(function () {
        cur.classList.remove('is-on', 'is-leaving');
        at = (at + 1) % msgs.length;
        msgs[at].classList.add('is-on');
        setTimeout(next, HOLD_MS[at % HOLD_MS.length]);
      }, LEAVE_MS);
    }
    setTimeout(next, HOLD_MS[0]);
  }

  document.querySelectorAll('[data-btk-sales-banner]').forEach(start);
})();
